import * as CONST from '../ActionTypes';

const initialState = {
  isChangeCart: false,
  // eslint-disable-next-line no-irregular-whitespace
  isBuyProduct: false, // buy タワー型噴霧器　TERRA FORESTAミスト
  total: 0,
  cartsDB: [],
  cartsLocal: [],
};

function cart(state = initialState, action) {
  switch (action.type) {
    // -----------------
    // カート更新フラグ
    // -----------------
    case CONST.TOGGLE_CHANGE_CART:
      return {
        ...state,
        isChangeCart: action.payload,
      };
    // -----------------
    // 合件設定
    // -----------------
    case CONST.SET_TOTAL_CART:
      return {
        ...state,
        total: Number(action.payload),
      };
    // -----------------
    // カート一覧取得
    // -----------------
    case CONST.GET_CART_LIST_SUCCESS:
      return {
        ...state,
        cartsDB: action.payload,
      };
    case CONST.GET_CART_LIST_FAILURE:
      return {
        ...state,
        cartsDB: [],
      };
    // -----------------
    // ローカルカート一覧取得
    // -----------------
    case CONST.GET_CART_LIST_LOCAL_SUCCESS:
      return {
        ...state,
        cartsLocal: action.payload,
      };
    case CONST.DELETE_CART_ITEM_SUCCESS:
      return {
        ...state,
        cartsDB: action.payload,
      };
    // -----------------
    // カート削除
    // -----------------
    case CONST.DELETE_CART:
      return {
        ...state,
        cartsDB: [],
        cartsLocal: [],
      };
    case CONST.GET_BUY_HISTORY_SUCCESS:
      return {
        ...state,
        isBuyProduct: action.payload,
      };
    case CONST.GET_BUY_HISTORY_FAILURE:
      return {
        ...state,
        isBuyProduct: false,
      };
    default:
      return state;
  }
}

export default cart;
